module.exports = __webpack_public_path__ + "img/activecertificate.1a033b81.svg";